import api from "../../api.js";

export async function getPatients(search) {
  const res = await api.get("/api/clinic/booking/patients", {
    params: search ? { search } : undefined,
  });
  return res.data?.data || [];
}

export async function getServices() {
  const res = await api.get("/api/clinic/booking/services");
  return res.data?.data || [];
}

export async function getAppointments() {
  const res = await api.get("/api/clinic/booking/appointments");
  return res.data?.data || [];
}

export async function createAppointment(payload) {
  const res = await api.post("/api/clinic/booking/appointments", payload);
  return res.data;
}

export async function deleteAppointment(appointmentId) {
  await api.delete(`/api/clinic/booking/appointments/${appointmentId}`);
  return true;
}

export async function updateAppointmentStatus(appointmentId, status) {
  if (!appointmentId) {
    throw new Error("Appointment ID is required");
  }
  const res = await api.put(`/api/clinic/appointments/${appointmentId}/status`, { status });
  return res.data?.data;
}
